module.exports = __webpack_public_path__ + "media/images/ibjjf/membership/card-bullet-35cea7a96f25a65c77ccb3578f2eb5f9.svg";